import React, { useEffect, useState } from 'react'
import { get } from '../../services/api';

const DeliveryPage = () => {
    const token = localStorage.getItem("token");
    const organizationId = localStorage.getItem("organizationId");
    const userId = localStorage.getItem("userId");  
    const [billingOption, setBillingOption] = useState('same');

    const [cartItems , setCartItems] = useState([]); 
    const baseUrl = process.env.REACT_APP_LIVE_DOMAIN_URL
  const fetchItems = async (id) => {
    try
    {
      const response = await get(
            `Order/delivery-items/${id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          console.log("item", response)
          setCartItems(response)
        } catch (error) {
          setCartItems([])
          console.error("Error fetching items:", error);
        }
      };
          useEffect(() => {
            if (userId) {
              fetchItems(userId);
            } else {
              setCartItems([]);
            }
          }, [userId]);
  const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const shipping = 0;
  const total = subtotal + shipping;
  return (
   <div className="row g-3">

  <div className="col-md-6">
    <div className="card">
      <div className="card-body">

      
   
<h5 className="mt-4 mb-2">Payment</h5>
<small className="text-muted">Please Click the button for payment</small>



<div className="mt-3">
  <a
    href="" 
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-outline-primary w-100"
  >
    Open Payment Link
  </a>
</div>


<div className="mt-3">
  <label className="form-label fw-bold">Attach Proof of Payment</label>
  <input type="file" className="form-control" />
</div>


<h5 className="mt-4 mb-2">Billing address</h5>


<div
  className="form-check d-flex justify-content-between align-items-center p-2 border border-primary rounded"
  style={{ backgroundColor: '#F0F5FF' }}
>
  <label className="form-check-label mb-0" style={{ color: 'black', fontWeight: 'bold' }}>
    Campus
  </label>
  <input
    className="form-check-input"
    type="radio"
    name="billing"
    id="campusBilling"
    checked={billingOption === 'campus'}
    onChange={() => setBillingOption('campus')}
  />
</div>


<div
  className="form-check d-flex justify-content-between align-items-center p-2 border border-primary rounded mt-2"
  style={{ backgroundColor: '#F0F5FF' }}
>
  <label className="form-check-label mb-0" style={{ color: 'black', fontWeight: 'bold' }}>
    Use a different billing address
  </label>
  <input
    className="form-check-input"
    type="radio"
    name="billing"
    id="differentBilling"
    checked={billingOption === 'different'}
    onChange={() => setBillingOption('different')}
  />
</div>


{billingOption === 'different' && (
  <div className="mt-3">

    <div className="mb-3">
      <select className="form-select">
        <option value="">Pakistan</option>
        <option value="PK">Pakistan</option>
      </select>
    </div>


    <div className="row g-2">
      <div className="col-md-6">
        <input type="text" className="form-control" placeholder="First name" />
      </div>
      <div className="col-md-6">
        <input type="text" className="form-control" placeholder="Last name" />
      </div>
    </div>


    <div className="mt-3">
      <input type="text" className="form-control" placeholder="Address" />
    </div>

    <div className="row g-2 mt-2">
      <div className="col-md-6">
        <input type="text" className="form-control" placeholder="City" />
      </div>
      <div className="col-md-6">
        <input type="text" className="form-control" placeholder="Postal code (optional)" />
      </div>
    </div>

   
    <div className="mt-3">
      <input type="text" className="form-control" placeholder="Phone (optional)" />
    </div>
  </div>
)}

       <div className="mt-4">
        <button type="submit" className="btn btn-primary w-100">
          Complete Payment
        </button>
      </div>
 
      </div>
    </div>
  </div>

   <div className="col-md-6">
      <div className="card">
        <div className="card-body">

          <h5 className="mb-4">Your Items</h5>

       <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
  {cartItems.map((item) => (
    <div className="d-flex mb-3" key={item.id}>
  
  <div className="position-relative me-3">
    
   
      <span
        className="position-absolute top-0 end-0 badge rounded-circle bg-primary"
        style={{
          transform: 'translate(50%, 0%)',
          zIndex: 1,
          padding: '6px 10px',
          fontSize: '12px',
        }}
      >
        {item.quantity}
      </span>
    

  
    <img
        src={`${baseUrl}${item.image}`}
      alt={item.title}
      style={{
        width: '80px',
        height: '80px',
        objectFit: 'cover',
        borderRadius: '6px',
      }}
    />
  </div>

  <div className="w-100">
    <div className="d-flex justify-content-between">
      <div>
        <strong>{item.title}</strong>
      
        <div className="text-muted small">
          {[item.height, item.season, item.className].filter(Boolean).join(" / ")}
        </div>
      </div>
      <div className="fw-bold">Rs {item.price * item.quantity}</div>
    </div>
  </div>
</div>

  ))}
</div>


          <hr />

         
          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">Subtotal · {cartItems.reduce((sum, item) => sum + item.quantity, 0)} items</span>
            <span>Rs {subtotal.toLocaleString()} </span>
          </div>

          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">Shipping</span>
            <span>Rs {shipping} </span>
          </div>

 

          <div className="d-flex justify-content-between fw-bold fs-6" style={{color :'black'}}>
            <span>Total</span>
           
            <span> <span style={{fontSize:'14px', color:'grey'}}>PKR</span> Rs {total.toLocaleString()} </span>
          </div>

        </div>
      </div>
    </div>

</div>

  )
}

export default DeliveryPage
